import { Box, Grid2, TableCell, Typography } from "@mui/material";
import React, { useState } from "react";
import CommonButton from "../../../../../component/Button";
import FileUpload from "./FileUpload";
import {
  DotColor,
  StatusChange,
  StyledFlexColumnView,
} from "../../../../common-components/StyledComponents";
import DropDownSelect from "../../../../../component/Select";
// import { StyledSpaceBetweenBox } from "../../../../../quick-match/components/StyledComponent";
import CommonTable from "../../../../candidates/Table";
import DotsVerticalIco from "../../../../../assets/icons/DotsVerticalIco";
import ShareQuickMatch from "../../../quick-match/components/ShareQuickMatch";
import { StyledSpaceBetweenBox } from "../../../quick-match/components/StyledComponent";
const headerData = ["ID", "Email Address", "Assignment", "Result", "Date", ""];

const statusColors = {
  Submitted: "#17B26A",
  "In Progress": "#F79009",
};

const data = [
  {
    id: "001",
    email: "zahirmays@talairo.com",
    assignment: "Coversheet",
    result: "Submitted",
    date: "Oct 10, 2024",
    status: "Active",
  },
  {
    id: "002",
    email: "phoenixbaker@talairo.com",
    assignment: "Coversheet",
    result: "Submitted",
    date: "Oct 12, 2024",
    status: "Active",
  },
  {
    id: "003",
    email: "freyabrowning@talairo.com",
    assignment: "Coversheet",
    result: "In Progress",
    date: "-",
    status: "Active",
  },
];

function UploadCandidate({
  handleCandidateDragOver,
  handleCandidateDragLeave,
  handleCandidateDrop,
  handleCandidateFileUpload,
  candidateFiles,
  getFileIcon,
  isCandidateDragging,
  handleCandidateDeleteFile,
  handleGenerateUploadClick,
  tabData,
  isLoading,
  buttonDisabled,
  selectAnalysis,
  selectAnalysisDropDownData,
  handleChangeSelectAnalysis,
}) {
  const [shareDialogOpen, setShareDialogOpen] = useState({
    open: false,
    loading: false,
  });

  const handleOpenInvite = () => {
    setShareDialogOpen({ open: true, loading: false });
  };
  const handleShareDialogClose = () => {
    setShareDialogOpen({ open: false, loading: false });
  };
  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    return (
      <>
        <TableCell>{row.id || "-"}</TableCell>
        <TableCell>{row.email}</TableCell>
        <TableCell>{row.assignment}</TableCell>

        <TableCell>
          <StatusChange>
            <DotColor color={statusColors[row.result] || "#667085"} />
            {row.result || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>{row.date}</TableCell>

        <TableCell>
          <DotsVerticalIco />
        </TableCell>
      </>
    );
  };
  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12}>
        <Box width={"600px"} margin={"auto"}>
          <StyledFlexColumnView>
            <Typography color="#344054" fontSize="14px">
              {"Select Analysis Model"}
            </Typography>
            <DropDownSelect
              marginTop="0px"
              removeAnimation={true}
              value={selectAnalysis}
              handleChange={(e) => handleChangeSelectAnalysis(e.target.value)}
              data={selectAnalysisDropDownData}
            />
          </StyledFlexColumnView>

          {selectAnalysis === "Conduct Assessment Anonymously" ? (
            <>
              <Typography
                fontWeight={500}
                fontSize={"16px"}
                marginBottom={2}
                marginTop={2}
              >
                {"Upload Leadership Team Profiles"}
              </Typography>
              <FileUpload
                onDragOver={handleCandidateDragOver}
                onDragLeave={handleCandidateDragLeave}
                onDrop={handleCandidateDrop}
                onChange={handleCandidateFileUpload}
                isDragging={isCandidateDragging}
                files={candidateFiles}
                getFileIcon={getFileIcon}
                handleDeleteFile={handleCandidateDeleteFile}
                disabled={isLoading}
              />{" "}
            </>
          ) : (
            <></>
          )}
        </Box>
      </Grid2>

      {selectAnalysis === "Get data from Candidates to Analyze" ? (
        <>
          <Grid2 size={12}>
            <StyledSpaceBetweenBox sx={{ marginTop: "20px" }}>
              <Typography color="#101828" fontSize="20px" fontWeight={600}>
                {"Leadership Team"}
              </Typography>

              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                value="Invite Member"
                padding={"10px 12px"}
                onClick={handleOpenInvite}
              />
            </StyledSpaceBetweenBox>
          </Grid2>

          <Grid2 size={12}>
            <CommonTable
              data={data}
              columns={headerData}
              // sortedColumns={sortItem}
              // onSortChange={(col) => console.log("Sort by", col)}
              handleTableBodyData={handleTableBodyData}
              marginTop={"0px"}
            />
          </Grid2>
        </>
      ) : null}

      <Grid2 size={12}>
        <Box width={"600px"} margin={"auto"}>
          <CommonButton
            width={"100%"}
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Generate Report"
            padding={"10px 0px"}
            onClick={handleGenerateUploadClick}
            disabled={tabData[2].disabled === false || buttonDisabled}
            loading={tabData[2].disabled === false || isLoading}
          />
        </Box>
      </Grid2>

      <ShareQuickMatch
        title="Invite Members"
        shareDialogOpen={shareDialogOpen.open}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareDialogClose}
        isLoading={shareDialogOpen.loading}
        shareButtonLabel={"Invite"}
      />
    </Grid2>
  );
}

export default UploadCandidate;
